'use strict';

// Main dependencies imports
import Lenis from 'lenis';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";

// Internal modules imports
import lenis from './modules/lenis.mjs';
import scrollReveal from "./modules/scroll-reveal.mjs";
import header from "./modules/header.mjs"
import anchor from "./modules/anchor.mjs";
import parallax from "./modules/parallax.mjs";
import toTop from "./modules/to-top.mjs";

// Expose globally for legacy jQuery projects
window.GSAP = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.Lenis = Lenis;

// Re-export for modern projects
export { gsap, ScrollTrigger, ScrollToPlugin, Lenis };

const init = () => {
    lenis.init();
    scrollReveal.init();
    header.init();
    anchor.init();
    parallax.init();
    toTop.init();
}

const scrollToTop = () => {
    lenis.scrollToTop();
}

const initLenis = () => {
    lenis.init();
}

const initScrollReveal = () => {
    scrollReveal.init();
}

const initHeader = () => {
    header.init();
}

const initAnchor = () => {
    anchor.init();
}

const initParallax = () => {
    parallax.init();
}

const initToTop = () => {
    toTop.init();
}

export default {init, scrollToTop, initLenis, initScrollReveal, initHeader, initAnchor, initParallax, initToTop}
